import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './auth/AuthProvider';
import { I18nProvider } from './i18n/I18nProvider';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nProvider><AuthProvider><App /></AuthProvider></I18nProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// The static splash guarantees a deliberate first paint while the auth client
// and initial route are loading. Keep it briefly after React owns the UI: a
// one-frame flash is neither useful nor visible to a person.
window.setTimeout(() => {
  const splash = document.getElementById('driveros-splash');
  if (!splash) return;
  splash.hidden = true;
  window.setTimeout(() => splash.remove(), 220);
}, 700);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
